// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "router." + chunkId + "." + {"25": "22e90b16edb2185f","29": "c153f5966ac10051","355": "4fb167fb97ee5986","404": "2130a800c93d2b3a","522": "0fa94e7201289e23","531": "bef7deec0349337c","60": "6274727348e2924c","671": "e8c6ce52b2c7c40d","694": "4dbc9a1f706563c8","820": "e8cb741b1ad8748e","857": "859587ef7ec559c8","901": "68b4e4f27e4396bf","942": "9d55a95cc9975184","994": "b7b236f92f1f9d00",}[chunkId] + ".js"
}